export const itemsSuppliersColumns = [
    {
        Header: 'Id',
        accessor: 'id',
    },
    {
        Header: 'Suppliers Name',
        accessor: 'suppliersName',
    },
    {
        Header: 'Email',
        accessor: 'email',
    },
    {
        Header: 'Mobile',
        accessor: 'mobile',
    },
    {
        Header: 'Address',
        accessor: 'address',
    },
    {
        Header: 'Actions',
        accessor: 'actions',
    }
  ];

export const itemsSuppliersTableData = [
    {   
        id:'1101',
        suppliersName:'jemy',
        email: 'jemy@gmail.com',
        mobile: '(555) 123-4567',
        address: 'Sydney New South Wales 2000 Australia',
    },
    {   
        id:'1102',
        suppliersName:'Aura',
        email: 'aura@gmail.com',
        mobile: '(555) 234-5678',
        address: 'New South Wales Sydney',
    },
    {   
        id:'1103',
        suppliersName:'John Smith',
        email: 'john.smith@gmail.com',
        mobile: '(555) 123-5567',
        address: '124 Main St, Anytown, USA',
    },
    {   
        id:'1104',
        suppliersName:'Sarah Brown',
        email: 'sarah.brown@gmail.com',
        mobile: '(555) 456-7890',
        address: '101 Pine St, Lakeside, USA',
    },
    {   
        id:'1105',
        suppliersName:'David Taylor',
        email: 'david.taylor@gmail.com',
        mobile: '(555) 567-8901',
        address: '222 Maple Ave, Rivertown, USA',
    },
    {   
        id:'1106',
        suppliersName:'Jennifer Miller',
        email: 'jennifer.miller@gmail.com',
        mobile: '(555) 678-9012',
        address: '333 Cedar St, Hillcrest, USA',
    },
    {   
        id:'1107',
        suppliersName:'Daniel Davis',
        email: 'daniel.davis@gmail.com',
        mobile: '(555) 789-0123',
        address: '444 Birch Ln, Meadowview, USA',
    },
    {   
        id:'1108',
        suppliersName:'Jessica Wilson',
        email: 'jessica.wilson@gmail.com',
        mobile: '(555) 890-1234',
        address: '555 Walnut St, Woodville, USA',
    },
]